<template>
  <div class="view know-how" data-name="know-how"></div>
</template>

<script>
export default {
  name: 'know-how',
  components: { },
};
</script>
